<template>
  <v-flex>
    <v-dialog v-if="this.modelCliente" v-model="dialogFormularioCliente" :max-width="900" persistent>
      <cliente-formulario @cerrarFormularioCliente="dialogFormularioCliente = false" :modelCliente="this.modelCliente"
        :accion="this.accion" />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el cliente?
            </v-label>
          </v-row>
          <v-row class="mt-4 mb-4" justify="center">
            <v-label v-if="clienteSelec" :dark="dark">
              Si el cliente tiene reservas también serán eliminadas.
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarCliente()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Clientes</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearCliente">
          <!-- <v-avatar left>
            <v-icon size="20" color="white">mdi-account-plus</v-icon>
          </v-avatar> -->
          <span v-bind:style="{ color: 'white' }">
            Nuevo Cliente
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaNombre" autocomplete="off"
              label="Búsqueda por nombre" placeholder="Especifique parte del nombre o los apellidos"
              @keyup.enter="_getClientes(true)" dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaTelefono" autocomplete="off"
              label="Busqueda por teléfono" placeholder="Teléfono del cliente" @keyup.enter="_getClientes(true)"
              dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaEmail" autocomplete="off"
              label="Busqueda por email" placeholder="Email del cliente" @keyup.enter="_getClientes(true)"
              dense></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="clientes" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table v-if="clientes" locale="es" dense :headers="headersLargo" :items="clientes"
              :server-items-length="totalClientes" :options.sync="options"
              class="elevation-1 alternating-rows bordered-table" :footer-props="{
                'items-per-page-options': [20, 50, 100],
                'items-per-page-text': 'Clientes por página',
              }" @update:options="handleUpdateOptions">




              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="_editar(item)">
                      <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_delete(item)">
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                No hay datos disponibles
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ClienteFormulario from "../components/formularios/ClienteFormulario";

export default {
  components: {
    ClienteFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    accion: "",

    dialogFormularioCliente: false,
    modelCliente: null,
    showConfirmacionEliminacion: false,


    options: {},
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'nombre',

    headersLargo: [
      {
        text: "TIPO",
        align: "left",
        sortable: false,
        value: "tipoCliente",
      },

      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      {
        text: "APELLIDOS",
        align: "left",
        sortable: false,
        value: "apellidos",
      },
      { text: "TELÉFONO", align: "left", sortable: false, value: "telefono" },
      {
        text: "EMAIL",
        align: "left",
        sortable: false,
        value: "email",
      },
      {
        text: "DOCUMENTO",
        align: "left",
        sortable: false,
        value: "documento",
      },
      {
        text: "PASAPORTE",
        align: "left",
        sortable: false,
        value: "pasaporteNumero",
      },
      {
        text: "DIRECCION",
        align: "left",
        sortable: false,
        value: "direccion",
      },
      {
        text: "COMENTARIOS",
        align: "left",
        sortable: false,
        value: "comentarios",
      },
      { text: "", width: "10px", value: "actions", sortable: false, align: "center" },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("clientes", ["clientes", "clienteSelec", "totalClientes"]),
  },

  watch: {},

  mounted() {
    this._getClientes(true);

  },

  methods: {
    ...mapActions("clientes", ["getClientes", "eliminarCliente", "updateCliente"]),
    ...mapMutations("clientes", ["setClienteSelec"]),

    _inicializarModelCliente() {
      this.modelCliente = {
        id: null,
        tipoCliente: null,
        nombre: null,
        apellidos: null,
        telefono: null,
        email: null,
        documento: null,
        pasaporteNumero: null,
        direccion: null,
        comentarios: null,
      };
    },

    rowClass(item, index) {
      return index % 2 === 0 ? 'light-blue-row' : '';
    },

    handleUpdateOptions(newOptions) {
      // Solo actualizamos si realmente ha cambiado algo relevante
      if (newOptions.page !== this.currentPage || newOptions.itemsPerPage !== this.itemsPerPage) {
        this.currentPage = newOptions.page;
        this.itemsPerPage = newOptions.itemsPerPage;
        this._getClientes(false);
      }
    },



    _imprimir() { },

    async _getClientes(showload) {
      const params = {};

      params.page = this.currentPage;
      params.per_page = this.itemsPerPage;
      params.sort_by = this.sortBy;

      if (this.busquedaNombre != null && this.busquedaNombre != "") {
        params.nombre = this.busquedaNombre;
      }
      if (this.busquedaTelefono != null && this.busquedaTelefono != "") {
        params.telefono = this.busquedaTelefono;
      }
      if (this.busquedaEmail != null && this.busquedaEmail != "") {
        params.email = this.busquedaEmail;
      }
      await this.getClientes([this.access_token, params, true]);
    },

    _delete(item) {
      this.setClienteSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _crearCliente() {
      this._inicializarModelCliente();
      this.accion = 'crear';
      this.dialogFormularioCliente = true;
    },

    _editar(item) {
      this.setClienteSelec(item);
      let temp = JSON.parse(JSON.stringify(this.clienteSelec));
      this.modelCliente = temp;
      this.accion = 'editar';
      this.dialogFormularioCliente = true;
    },

    async _eliminarCliente() {
      this.showConfirmacionEliminacion = false;
      if (this.clienteSelec != null) {
        await this.eliminarCliente([this.access_token, this.clienteSelec.id]);
      }
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}


.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
